import React, { useState, useEffect, useRef } from 'react';
import { Theme, FormControl } from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';
import Button from '../components/custom-button';
import RoleRadio from '../components/role-radio';
import Icon from '../components/icon';
import FormInput from '../components/form-input';
import FormSelect from '../components/form-select';
import LangSelect from '../components/lang-select';
import { isElectron } from '../utils/platform';
import { usePlatform } from '../containers/platform-container';
import {useHistory} from 'react-router-dom';
import { roomStore } from '../stores/room';
import { genUid } from '../utils/helper';
import MD5 from 'js-md5';
import { globalStore, roomTypes } from '../stores/global';
import { t } from '../i18n';
import {getClassList, getHeathStatus, getRtcToken,getRtmToken} from '../utils/api/request';
import { useRoomState } from '../containers/root-container';
import GlobalStorage from '../utils/custom-storage';
import {url} from "inspector";

//user define
import Grid, { GridSpacing } from '@material-ui/core/Grid';
import Container from '@material-ui/core/Container';
import './home.scss';
import Pagination from '@material-ui/lab/Pagination';
import {number} from "prop-types";
const useStyles = makeStyles ((theme: Theme) => ({
  formControl: {
    minWidth: '240px',
    maxWidth: '240px',
  }
}));
type LiveClassroomList={
    id: number
    startTime: number
    name: string
    roomType: number
    roomId: string
}

type ClassListInfo={
    userId : number
    teacherId:number
    userName: string
    sign: number
    urlImg: string
    crmLiveClassroomList: any []
}
const defaultClassListInfoState: ClassListInfo = {
    userId: 0,
    teacherId: 0,
    userName: "码高",
    sign: 0,
    urlImg: "http://crm.img.magaoedu.cn/cc99af1b4b704de95abf3a24c2f5f09f.jpg",
    crmLiveClassroomList:[]
}


type SessionInfo = {
  roomName: string
  roomType: number
  yourName: string
  role: string
}

const defaultState: SessionInfo = {
  roomName: '',
  roomType: 1,
  role: '',
  yourName: '',
}
type Pageable = {
    pageNumber: number
    pageSize: number
    pageCount:number
    pageTotal:number;
}
//渲染列表
function HomePage() {

    const [classListInfo, setClassListInfo] = useState<ClassListInfo>(defaultClassListInfoState);

    const [pageable, setPageable] = useState<Pageable>({pageNumber:1,pageSize:3,pageCount:0,pageTotal:0});

    const [session, setSessionInfo] = useState<SessionInfo>(defaultState);

    const [required, setRequired] = useState<any>({} as any);

    const [loading, setLoading] = useState<boolean>(false);
   function onLoad(success:any){

       setClassListInfo({
           ...success.data.token,
           crmLiveClassroomList:success.data.crmLiveClassroomList
       })
       //(rowCount + pageSize - 1)/pageSize
       let pageCount =Math.ceil(success.pagebar.total/pageable.pageSize);
       setPageable({
           ...pageable,
           pageTotal: success.pagebar.total,
           pageCount:pageCount
       })
    }

   //检验token的存活时间 , 若大于12小时过期为健康状态 , 否则跳转到登录页面 , 刷新token
   const   isHeath = ()=>{
       getHeathStatus().then((success: any) => {
           //获取列表成功后
           if(success.status==500){
               history.push('/');
           }
       }, (error: any) => {
          history.push('/');
       })
   }



  //进入页面获取教室信息
  useEffect(()=>{
      isHeath();
      getClassList(pageable).then((success: any) => {
          //获取列表成功后
          onLoad(success);
      }, (error: any) => {
          history.push('/');

      })
  },[pageable.pageNumber])


  document.title = t(`home.short_title.title`)
  const classes = useStyles();

  const history = useHistory();

  const handleSetting = (evt: any) => {
    history.push({pathname: `/device_test`});
  }

  const {
    HomeBtn
  } = usePlatform();

  const ref = useRef<boolean>(false);

  useEffect(() => {
    return () => {
      ref.current = true;
    }
  }, []);


   const loginOut=()=>{
       localStorage.removeItem('online-token');
       history.push('/');
    }
    const formatDate=(longTime :number)=>{
         let date = new Date(longTime);
         let hour=date.getHours();
         let minute=date.getMinutes();

         return (hour<10?'0'+hour:hour)+':'+ (minute<10?'0'+minute:minute);
    }
    const handleSubmit = (item:any) => {

    // if (!session.roomName) {
    //   setRequired({...required, roomName: t('home.missing_room_name')});
    //   return;
    // }
    //
    // if (!session.yourName) {
    //   setRequired({...required, yourName: t('home.missing_your_name')});
    //   return;
    // }
    //
    // if (!session.role) {
    //   setRequired({...required, role: t('home.missing_role')});
    //   return;
    // }
    // if (!roomTypes[1]) return;
    const path = roomTypes[1].path
     // const userId =   `${classListInfo.userId}${genUid()}`
        const userId =   `${classListInfo.userId}`
            const payload = {
                uid: userId,
                // rid: `${MD5(item.name)}`,
                rid: `${item.id}`,
                role: classListInfo.sign==0?'teacher':'student',
                roomName: item.name,
                roomType: 1,
                video: 1,
                audio: 1,
                chat: 1,
                account: classListInfo.userName,
                rtmToken: '',
                boardId: '',
                linkId: 0,
                sharedId: 0,
                lockBoard: 0,
                grantBoard: 0,
            }
            ref.current = true;
            setLoading(true);
            // globalStore.showLoading();
            roomStore.loginAndJoin(payload).then(() => {
                history.push(`/classroom/${path}`);
            }).catch((err: any) => {
                if (err.reason) {
                    globalStore.showToast({
                        type: 'rtmClient',
                        message: t('toast.rtm_login_failed_reason', {reason: err.reason}),
                    })
                } else {
                    globalStore.showToast({
                        type: 'rtmClient',
                        message: t('toast.rtm_login_failed'),
                    })
                }
                console.warn(err);
            })
                .finally(() => {
                    ref.current = false;
                    // globalStore.stopLoading();
                    setLoading(false);
                })

  }

    const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
        setPageable({
            ...pageable,
            pageNumber: value,
        })
    };
  return (
      <div  className="home-class-room_background" style={{width:'100%'}} >
          <div className="home-fly-man"></div>
          <div className="home-fly-star"></div>
          <div className="home-fly-star-middle"></div>
          {
              loading==true?<div className='classroom-mask'>
              <div className='classroom-loading-wrapper'>
                  <div className='classroom-loading'></div>
              </div>
          </div>:null
          }

          <Container fixed style={{width:'100%' , height:'100%',minWidth:'960px'}}  >
              <Grid
              container
              direction="column"
              justify="flex-start"
              // alignItems="center"
              style={{width:'100%' , height:'100%'}}
              wrap="nowrap"
          >
              <div  className="navigation-list-wrapper" >
                  <Grid
                      container
                      direction="row"
                      justify="space-between"
                      // alignItems="flex-start"
                      wrap="nowrap"
                  >
                      <a href="https://cloud.magaoedu.com/" target="_blank"> <div  className="logo" ></div></a>
                      <div className="navigation-list">
                          <Grid
                              container
                              direction="row"
                              justify="space-between"
                              // alignItems="center"
                              className="navigation"
                          >
                              <a href="https://cloud.magaoedu.com/" target="_blank"><div >Scratch云课堂</div></a>
                                  <a href="https://cloud.magaoedu.com/" target="_blank">   <div >Python云课堂</div></a>
                                      <a href="https://cloud.magaoedu.com/" target="_blank">  <div >C++云课堂</div></a>
                                          <a href="https://cloud.magaoedu.com/" target="_blank">  <div >云听课堂</div></a>
                                              <a href="https://cloud.magaoedu.com/" target="_blank">  <div >下载中心</div></a>
                          </Grid>

                      </div>
                      <div  className="user-info"  onClick={loginOut}>
                          <img src={classListInfo.urlImg} style={{height :'100%' ,width: '100%'}}/>
                      </div>
                  </Grid>
              </div>
              <div className='classroom-cards-container'>


                  <Grid
                      container
                      direction="column"
                      justify="flex-start"
                      wrap="nowrap"
                      className='classroom-cards'
                  >


                      {classListInfo.crmLiveClassroomList.map(
                          (item:any,key: number)=>(
                              <div key={key}>
                                  <div className='classroom-card-header'>
                                      <div className='classroom-card-icon'>
                                          <img src='https://source.magaoedu.com/magao-card-icon.png'/>

                                      </div>
                                      <div className='classroom-card-teacher-name'>{item.teacherName}老师</div>
                                  </div>
                                  <div>

                                      <div className='classroom-card-title'>
                                          {item.name}
                                      </div>
                                      <div className={item.roomType==0?'classroom-card-type-red':'classroom-card-type-blue'}>{item.roomType==0?'系统课':'体验课'}</div>
                                      <div>
                                          <span className='classroom-card-desc'>码高云听课堂</span>
                                          <span className='classroom-card-id'>教室ID:{item.roomId}</span>
                                      </div>

                                      <div>
                                          <div className='classroom-card-gold'></div>
                                          <span>50</span>
                                      </div>
                                  </div>
                                  <div>
                                      <span className='classroom-card-time'>{formatDate(item.startTime)}</span>
                                      <div className='classroom-card-to-live' onClick={() => handleSubmit(item)}></div>
                                  </div>
                              </div>
                          )
                      )}


                  </Grid>


              </div>
              {
                  pageable.pageTotal>3? <div className='pagination'>
                      <Pagination onChange={handleChange} count={pageable.pageCount}  page={pageable.pageNumber}  variant="outlined" shape="rounded" color="secondary" />
                  </div>:null
              }

          </Grid>
          </Container>
      </div>

        // <div className={`flex-container ${isElectron ? 'draggable' : 'home-cover-web' }`}>
        //   {isElectron ? null :
        //   <div className="web-menu">
        //     <div className="web-menu-container">
        //       <div className="short-title">
        //         <span className="title">{t('home.short_title.title')}</span>
        //       </div>
        //     </div>
        //   </div>
        //   }
        //   <div className="custom-card">
        //     <div className="flex-item cover">
        //       {isElectron ?
        //       <>
        //       <div className={`short-title ${globalStore.state.language}`}>
        //         <span className="title">{t('home.short_title.title')}</span>
        //         <span className="subtitle">{t('home.short_title.subtitle')}</span>
        //       </div>
        //       <div className={`cover-placeholder ${t('home.cover_class')}`}></div>
        //       <div className='build-version'>{t("build_version")}</div>
        //       </>
        //       : <div className={`cover-placeholder-web ${t('home.cover_class')}`}></div>
        //       }
        //     </div>
        //     <div className="flex-item card">
        //       <div className="position-top card-menu">
        //         <HomeBtn handleSetting={handleSetting}/>
        //       </div>
        //       <div className="position-content flex-direction-column">
        //         <FormControl className={classes.formControl}>
        //           <FormInput Label={t('home.room_name')} value={session.roomName} onChange={
        //             (val: string) => {
        //               setSessionInfo({
        //                 ...session,
        //                 roomName: val
        //               });
        //             }}
        //             requiredText={required.roomName}
        //           />
        //         </FormControl>
        //         <FormControl className={classes.formControl}>
        //           <FormInput Label={t('home.nickname')} value={session.yourName} onChange={
        //             (val: string) => {
        //               setSessionInfo({
        //                 ...session,
        //                 yourName: val
        //               });
        //             }}
        //             requiredText={required.yourName}
        //           />
        //         </FormControl>
        //         <FormControl className={classes.formControl}>
        //           <FormSelect
        //             Label={t('home.room_type')}
        //             value={session.roomType}
        //             onChange={(evt: any) => {
        //               setSessionInfo({
        //                 ...session,
        //                 roomType: evt.target.value
        //               });
        //             }}
        //             items={roomTypes.map((it: any) => ({
        //               value: it.value,
        //               text: t(`${it.text}`),
        //               path: it.path
        //             }))}
        //           />
        //         </FormControl>
        //         <FormControl className={classes.formControl}>
        //           <RoleRadio value={session.role} onChange={(evt: any) => {
        //              setSessionInfo({
        //                ...session,
        //                role: evt.target.value
        //              });
        //           }} requiredText={required.role}></RoleRadio>
        //         </FormControl>
        //         <Button name={t('home.room_join')} onClick={handleSubmit}/>
        //       </div>
        //     </div>
        //   </div>
        // </div>
  )
}
export default React.memo(HomePage);
